module.exports = __webpack_public_path__ + "static/media/discontrol022.55ceff90.jpg";